import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CategoriesSection() {
  const { t } = useTranslation();

  const categories = [
    { labelKey: "nav.successStories", icon: "ri-trophy-line", path: "/success-stories", gradient: "from-orange-500 to-red-500", count: "180+" },
    { labelKey: "section.startups.title", icon: "ri-rocket-line", path: "/startups", gradient: "from-green-500 to-emerald-600", count: "120+" },
    { labelKey: "section.innovations.title", icon: "ri-lightbulb-line", path: "/innovations", gradient: "from-yellow-400 to-orange-500", count: "90+" },
    { labelKey: "section.femmes.title", icon: "ri-women-line", path: "/femmes-entrepreneures", gradient: "from-pink-500 to-rose-600", count: "75+" },
    { labelKey: "section.jeunesTalents.title", icon: "ri-star-line", path: "/jeunes-talents", gradient: "from-purple-500 to-violet-600", count: "60+" },
    { labelKey: "section.diaspora.title", icon: "ri-earth-line", path: "/diaspora-africaine", gradient: "from-teal-500 to-cyan-600", count: "45+" },
  ];

  const newRubriques = [
    {
      labelKey: "nav.interviews",
      icon: "ri-play-circle-line",
      path: "/interviews",
      bg: "bg-gray-900",
      border: "border-red-500/30",
      iconBg: "bg-red-500/20",
      iconColor: "text-red-400",
      textColor: "text-white",
      subColor: "text-gray-400",
      badgeKey: "categories.interviews.badge",
      badgeBg: "bg-red-500",
      descKey: "categories.interviews.desc",
    },
    {
      labelKey: "nav.opportunites",
      icon: "ri-compass-3-line",
      path: "/opportunites",
      bg: "bg-emerald-950",
      border: "border-emerald-500/30",
      iconBg: "bg-emerald-500/20",
      iconColor: "text-emerald-400",
      textColor: "text-white",
      subColor: "text-emerald-300/60",
      badgeKey: "categories.opportunites.badge",
      badgeBg: "bg-emerald-500",
      descKey: "categories.opportunites.desc",
    },
    {
      labelKey: "nav.formations",
      icon: "ri-graduation-cap-line",
      path: "/formations",
      bg: "bg-amber-950",
      border: "border-orange-500/30",
      iconBg: "bg-orange-500/20",
      iconColor: "text-orange-400",
      textColor: "text-white",
      subColor: "text-amber-300/60",
      badgeKey: "categories.formations.badge",
      badgeBg: "bg-orange-500",
      descKey: "categories.formations.desc",
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">

        {/* Classic categories */}
        <div className="text-center mb-10">
          <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("categories.title")}</h2>
          <p className="text-gray-500 mt-2 text-sm">{t("categories.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
          {categories.map((cat) => (
            <Link key={cat.path} to={cat.path} className="group cursor-pointer">
              <div className={`relative bg-gradient-to-br ${cat.gradient} rounded-2xl p-6 flex flex-col items-center justify-center gap-3 aspect-square hover:scale-105 transition-transform duration-300`}>
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className={`${cat.icon} text-white text-3xl`}></i>
                </div>
                <div className="text-center">
                  <div className="text-white font-bold text-sm leading-tight">{t(cat.labelKey)}</div>
                  <div className="text-white/70 text-xs mt-1">{cat.count} {t("categories.articles")}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* New rubriques */}
        <div className="border-t border-gray-100 pt-10">
          <div className="flex flex-wrap items-center gap-3 mb-6">
            <div className="w-10 h-1 rounded-full bg-gray-900"></div>
            <h3 className="text-lg font-bold text-gray-900 font-serif">{t("categories.newRubriques")}</h3>
            <span className="text-xs bg-orange-50 text-orange-600 font-bold px-3 py-1 rounded-full">{t("categories.tagline")}</span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {newRubriques.map((r) => (
              <Link
                key={r.path}
                to={r.path}
                className={`group flex items-center gap-4 ${r.bg} border ${r.border} rounded-2xl p-5 hover:-translate-y-1 hover:border-opacity-60 transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${r.iconBg} flex-shrink-0`}>
                  <i className={`${r.icon} ${r.iconColor} text-2xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`font-bold text-sm ${r.textColor}`}>{t(r.labelKey)}</span>
                    <span className={`text-white text-xs font-bold px-2 py-0.5 rounded-full ${r.badgeBg}`}>{t(r.badgeKey)}</span>
                  </div>
                  <p className={`text-xs ${r.subColor}`}>{t(r.descKey)}</p>
                </div>
                <i className={`ri-arrow-right-line ${r.iconColor} opacity-50 group-hover:opacity-100 group-hover:translate-x-1 transition-all flex-shrink-0`}></i>
              </Link>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
